/* eslint-disable react/jsx-key */
import PropTypes from "prop-types";
import { memo } from "react";
import { FormattedMessage } from "react-intl";
import { Amount } from "app/components/ui/Amount/Amount";
import { insuranceShape } from "app/utils/propTypes";
import classNames from "classnames";
import InsuranceContent from "app/pages/Booking/Payment/Insurances/InsuranceContent";
import "./insurances.scss";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import RadioFormik from "app/pages/.shared/form/RadioFormik";
import { useField } from "formik";

const Insurances = ({ insurances = [], intro, logo, onChange }) => {
	const [field] = useField("insurance");
	return (
		<div className="insurances">
			{intro && (
				<Typography
					variant={TYPOGRAPHY_VARIANTS.LARGE}
					isBold
					className="insurances__intro"
					component="h3"
				>
					<div>{intro}</div>
					<img className="insurances__logo" src={logo} />
				</Typography>
			)}

			{insurances.map((insurance, index) => {
				return (
					<div
						className={classNames("insurances__item", {
							"insurances__item--first": index === 0,
							"insurances__item--subsequent":
								index > 0 && index + 1 !== insurances.length,
							"insurances__item--last": index > 0 && index + 1 === insurances.length,
						})}
						key={insurance.code}
					>
						<RadioFormik
							name={"insurance"}
							id={insurance.code}
							value={insurance.code}
							showIcon={true}
							body={
								<InsuranceContent
									field={field}
									insurance={insurance}
									isFirstItem={index === 0}
								/>
							}
							toggle={() => {
								onChange(insurance);
							}}
							data-testid={`insurance-input-${insurance.code}`}
						>
							<div className="insurances__content">
								<div className="insurances__header">
									<div className="insurances__name">
										{insurance.title1 ? insurance.title1 : insurance.name}
									</div>
									{insurance.splittedPrice > 0 && (
										<div className="insurances__price">
											<Amount
												value={insurance.splittedPrice}
												size="xl"
												sign="+"
												signIsBold={false}
												signSize="regular"
											/>
											<div className="insurances__price__note">
												<FormattedMessage id="payment.insurance.price.per.day.per.person" />
											</div>
										</div>
									)}
								</div>
							</div>
						</RadioFormik>
					</div>
				);
			})}
		</div>
	);
};

Insurances.propTypes = {
	onChange: PropTypes.func,
	intro: PropTypes.string,
	logo: PropTypes.string,
	insurances: PropTypes.arrayOf(insuranceShape),
};

export default memo(Insurances);
